import React, { useEffect, useState } from "react";
import "./LeaveManagement.css";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import Layout from "../Components/Layout";
import axios from "axios";
import { capitalize } from "@mui/material";
import Applybtn from "../Assets/CSS/Button";
import {
  BigTexts,
  lastOne,
  LightDark,
  LighterBold,
  Lightight,
  smallText,
} from "../Assets/CSS/Text";
// import pdfImg from "../Assets/Images/Pdf-Img.png"
import pdfImg from "../Assets/Images/pdf2.png";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import EditLeave from "../Components/Model/EditLeave";
import toast from "react-hot-toast";

const LeaveManagement = () => {
  const navigate = useNavigate();
  const [leaveRecord, setLeaveRecords] = useState([]);

  const [totalLeves, setTotalLeves] = useState();
  const [usedLeaves, setUsedLeaves] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [loading, setLoading] = useState(true); // New state

  const [pageSize] = useState(30);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);

  const handleEditClick = (leave) => {
    setSelectedLeave(leave);
    setOpenEditModal(true);
  };
  const [leaveSummary, setLeaveSummary] = useState({
    totalLeaves: 0,
    leavesTaken: 0,
    remainingLeaves: 0,
  });

  const handleApplyClick = () => {
    navigate("/apply-leave");
  };
  const downloadPDF = async (endpoint, filename) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename || "document.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download PDF.");
    }
  };

  const fetchLeaveRecords = async () => {
    try {
      const token = localStorage.getItem("token"); // Or however you're storing it
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/leaves/my?page=${pageNumber}&size=${pageSize}`,
        // /api/v1/leaves

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          // params: {
          //   pageNumber,
          //   pageSize,
          // },
        }
      );

      console.log(response.data.content, "leave managemtnt ");
      setLeaveRecords(response.data.content || []);
    } catch (error) {
      console.error("Error fetching leave records:", error);
    } finally {
      setLoading(false);
    }
  };

  const featchTotalLeaves = async () => {
    try {
      const token = localStorage.getItem("token"); // Or however you're storing it
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/leave-balance/my`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("leaves titao", response);
      // setTotalLeves(response.data?.totalAllocatedLeave);
      // setUsedLeaves(response.data?.remainingTotalLeaveBalance);
      const data = response.data;

      // Calculate total leaves by summing all allocated leaves
      const totalAllocated =
        (data.totalAllocatedSickLeave || 0) +
        (data.totalAllocatedCasualLeave || 0) +
        (data.totalAllocatedEarnedLeave || 0);

      // Calculate remaining leaves by summing all remaining leaves
      const totalRemaining =
        (data.remainingSickLeave || 0) +
        (data.remainingCasualLeave || 0) +
        (data.remainingEarnedLeave || 0);

      // Leaves taken = total allocated - remaining
      const leavesTaken = totalAllocated - totalRemaining;

      setLeaveSummary({
        totalLeaves: totalAllocated,
        leavesTaken: leavesTaken,
        remainingLeaves: totalRemaining,
      });
    } catch (error) {
      console.error("Error fetching leave records:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateLeave = async (updatedLeave) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/leaves/${updatedLeave.leaveId}`,
        {
          leaveType: updatedLeave.leaveType,
          startDate: updatedLeave.startDate,
          endDate: updatedLeave.endDate,
          reason: updatedLeave.reason,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Update success:", response.data);
      toast.success("Leave Update successfully !!")

      // ✅ Refresh list after update
      fetchLeaveRecords();

      // ✅ Close modal
      setOpenEditModal(false);

    } catch (error) {
      console.error("Update error:", error);
      alert("Failed to update leave");
    }
  };

  const handleCancelLeave = async (leaveId) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/leaves/${leaveId}/cancel`,
        {}, // no body required
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Cancel success:", response.data);

      toast.success("Leave cancelled successfully!");

      // ✅ Refresh table
      fetchLeaveRecords();

      // ✅ Close modal
      setOpenEditModal(false);

    } catch (error) {
      console.error("Cancel error:", error);
      toast.error("Failed to cancel leave");
    }
  };

  useEffect(() => {
    fetchLeaveRecords();
    featchTotalLeaves();
  }, [pageNumber]);
  const formatReason = (text, wordsPerLine = 10) => {
    const words = text.split(" ");
    let formatted = "";

    for (let i = 0; i < words.length; i += wordsPerLine) {
      formatted += words.slice(i, i + wordsPerLine).join(" ") + "\n";
    }

    return formatted.trim();
  };

  return (
    // <Layout>
    <div>


      {/* <div className="backgound-main-content">
        <div className="leave-management-container"> */}
      <div className="header-section ">
        <div
          style={{ ...Applybtn, padding: "7px 20px" }}
          onClick={handleApplyClick}
        >
          <Icon
            icon="material-symbols:event-outline-rounded"
            className="apply-cal-icon fs-3  p-1 rounded"
          />
          <button className="apply-button">Apply for Leave</button>
        </div>
      </div>

      <div className="row mt-3 ">
        <div className="col-12 col-lg-4 mb-3">
          <div className="card">
            <div className="icon-container">
              <div className="stat-icon TotalLeave">
                <Icon
                  icon="material-symbols:event-outline-rounded"
                  className="icon fs-4"
                />
              </div>
            </div>
            <div className="card-content">
              <div style={Lightight}>Total Leaves for year</div>
              {/* <div className="value">{totalLeves ?? "-"}</div> */}
              <div className="value">
                {loading ? (
                  <Skeleton width={50} height={20} />
                ) : (
                  leaveSummary.totalLeaves
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-4 mb-3">
          <div className="card">
            <div className="icon-container">
              <div className="stat-icon LeaveTaken">
                <Icon
                  icon="material-symbols:event-outline-rounded"
                  className="icon fs-4"
                />
              </div>
            </div>
            <div className="card-content">
              <div style={Lightight}>Leaves Taken</div>
              <div className="value">
                {loading ? (
                  <Skeleton width={50} height={20} />
                ) : (
                  leaveSummary.leavesTaken
                )}
              </div>
            </div>

          </div>
        </div>
        <div className="col-12 col-lg-4 mb-3">
          <div className="card">
            <div className="icon-container">
              <div className="stat-icon LeaveTaken">
                <Icon
                  icon="material-symbols:event-outline-rounded"
                  className="icon fs-4"
                />
              </div>
            </div>
            <div className="card-content">
              <div style={Lightight}>Leaves Remaining</div>
              <div className="value">
                {loading ? (
                  <Skeleton width={50} height={20} />
                ) : (
                  leaveSummary.remainingLeaves
                )}
              </div>
            </div>

          </div>
        </div>
      </div>


      <div className="leave-records mt-2">
        <h6 style={BigTexts}>Leave Records</h6>

        {loading ? (
          <div className="records-loading">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="record-skeleton">
                <Skeleton height={25} />
              </div>
            ))}
          </div>
        ) : (
          <>
            {/* Desktop Table View */}
            <div className="records-table-container">
              <table className="records-table">
                <thead>
                  <tr>
                    <th>Date Applied</th>
                    <th>Leave Type</th>
                    <th>Date (From–To)</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {leaveRecord.map((record, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F7F7F7",
                      }}
                    >
                      <td>{new Date(record.appliedDate).toLocaleDateString("en-GB")}</td>
                      <td>{record.leaveType
                        .toLowerCase()
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase())}

                        {/* {record.leaveType} */}
                      </td>
                      <td>
                        {new Date(record.startDate).toLocaleDateString("en-IN")} –{" "}
                        {new Date(record.endDate).toLocaleDateString("en-IN")}
                      </td>
                      <td style={{ textAlign: "left", verticalAlign: "top" }}>
                        <div className="reason-scroll">
                          {record.reason}
                        </div>
                      </td>
                      <td>
                        <div
                          className={`status-badge ${record.leaveStatus === "APPROVED"
                            ? "approved"
                            : record.leaveStatus === "REJECTED" || record.leaveStatus === "CANCELLED"
                              ? "rejected"
                              : "pending"
                            }`}
                        >
                          <Icon
                            icon={
                              record.leaveStatus === "PENDING"
                                ? "mdi:clock-outline"
                                : record.leaveStatus === "APPROVED"
                                  ? "mdi:check-circle-outline"
                                  : "mdi:close-circle-outline"
                            }
                            width="18"
                            height="18"
                          />
                          <span>{record.leaveStatus}</span>
                        </div>


                      </td>
                      <td>
                        {record.leaveStatus === "PENDING" ? (
                          <button
                            className="edit-btn"
                            style={{ marginLeft: "0" }}
                            onClick={() => {
                              setSelectedLeave(record);
                              setOpenEditModal(true);
                            }}
                          >
                            Edit
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>



                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile Card View */}
            <div className="records-cards">
              {leaveRecord.map((record, index) => (
                <div className="record-card" key={index}>
                  <div className="d-flex justify-content-between ">
                    <div className="record-row">
                      <strong> {new Date(record.appliedDate).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                      </strong>{" "}

                    </div>
                    <div className="record-row">
                      <div
                        className={`status ${record.leaveStatus === "APPROVED"
                          ? "approved"
                          : record.leaveStatus === "REJECTED"
                            ? "rejected"
                            : "pending"
                          }`}
                      >

                        <span>{record.leaveStatus}</span>
                      </div>
                    </div>

                  </div>


                  <div className="record-row">
                    <h6 style={lastOne}>{record.leaveType
                      .toLowerCase()
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                    </h6>
                  </div>
                  <div className="record-row">
                    <div className="reason-scroll">{record.reason}</div>
                  </div>
                  <div className="record-row">
                    <div
                      style={{
                        display: "flex",
                        gap: '20px',
                        alignItems: "center",
                        marginBottom: "4px",
                      }}
                    >
                      <h6 style={smallText}>Date Applied</h6>
                      <h6 style={LightDark}>{new Date(record.appliedDate).toLocaleDateString("en-IN")}</h6>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: '31px',
                        marginBottom: "4px",
                      }}
                    >
                      <h6 style={smallText}>Date From</h6>
                      <h6 style={LightDark}>{new Date(record.startDate).toLocaleDateString("en-IN")} </h6>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: '47px',
                        marginBottom: "4px",
                      }}
                    >
                      <h6 style={smallText}>Date To</h6>
                      <h6 style={LightDark}> {new Date(record.endDate).toLocaleDateString("en-IN")}</h6>
                    </div>



                    <span></span>

                  </div>

                  <div className="record-row">

                    <div>
                      {record.leaveStatus === "PENDING" && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "10px",
                          }}
                        >
                          <button
                            className="edit-btn"
                            onClick={() => {
                              setSelectedLeave(record);
                              setOpenEditModal(true);
                            }}
                          >
                            Edit
                          </button>
                        </div>
                      )}
                    </div>
                  </div>


                </div>

              ))}
            </div>
          </>
        )}
      </div>



      <div className="leave-guidelines">
        <p className="section-title">Leaves Guidelines:</p>
        <div className="row mt-3">
          <div className="col-12 col-lg-4 mb-3">
            <div className="guideline-item">
              <div
                className="guideline-card"
                onClick={() =>
                  downloadPDF(
                    "/api/v1/employees/holiday-list",
                    "RAK_Holiday_List.pdf"
                  )
                }
              >
                <span style={LightDark}>RAK Holiday List</span>
                <Icon
                  icon="vscode-icons:file-type-pdf2"
                  width="28"
                  height="28"
                  className="pdf-icon"
                />
                {/* <img src={pdfImg} className=" pdf-icon"/> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-4 mb-3">
            <div className="guideline-item">
              <div
                className="guideline-card"
                onClick={() =>
                  downloadPDF(
                    "/api/v1/employees/leave-guidelines",
                    "Leave_Guidelines.pdf"
                  )
                }
              >
                <span>Leave Guidelines</span>
                <Icon
                  icon="vscode-icons:file-type-pdf2"
                  width="28"
                  height="28"
                  className="pdf-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <EditLeave
        openEditModal={openEditModal}
        setOpenEditModal={setOpenEditModal}
        selectedLeave={selectedLeave}
        setSelectedLeave={setSelectedLeave}
        handleUpdateLeave={(updatedLeave) => {
          console.log("Updated leave:", updatedLeave);
          setOpenEditModal(false);
        }}
      /> */}
      <EditLeave
        openEditModal={openEditModal}
        setOpenEditModal={setOpenEditModal}
        selectedLeave={selectedLeave}
        setSelectedLeave={setSelectedLeave}
        handleUpdateLeave={handleUpdateLeave}
        handleCancelLeave={handleCancelLeave}
      />


    </div>

  );
};

export default LeaveManagement;
